// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const StatsHttpPostAssets = 'StatsHttpPostAssets' as const;
export const StatsHttpGetAssetsByByPeriod =
  'StatsHttpGetAssetsByByPeriod' as const;
export const StatsHttpGetAutomationsUsageByDay =
  'StatsHttpGetAutomationsUsageByDay' as const;
export const StatsHttpGetBilling = 'StatsHttpGetBilling' as const;
export const StatsHttpPostBilling = 'StatsHttpPostBilling' as const;
export const StatsHttpGetBillingChargesByChargeIdReceiptUrl =
  'StatsHttpGetBillingChargesByChargeIdReceiptUrl' as const;
export const StatsHttpPostBillingCredits =
  'StatsHttpPostBillingCredits' as const;
export const StatsHttpGetBillingCreditsPrice =
  'StatsHttpGetBillingCreditsPrice' as const;
export const StatsHttpPostBillingCreditsVerify =
  'StatsHttpPostBillingCreditsVerify' as const;
export const StatsHttpGetBillingCustomer =
  'StatsHttpGetBillingCustomer' as const;
export const StatsHttpPostBillingCustomer =
  'StatsHttpPostBillingCustomer' as const;
export const StatsHttpDeleteBillingCustomerCard =
  'StatsHttpDeleteBillingCustomerCard' as const;
export const StatsHttpPostBillingCustomerCard =
  'StatsHttpPostBillingCustomerCard' as const;
export const StatsHttpGetBillingInvoices =
  'StatsHttpGetBillingInvoices' as const;
export const StatsHttpGetBillingPriceLists =
  'StatsHttpGetBillingPriceLists' as const;
export const StatsHttpPutBillingPriceLists =
  'StatsHttpPutBillingPriceLists' as const;
export const StatsHttpDeleteBillingPriceListsByNameByCurrency =
  'StatsHttpDeleteBillingPriceListsByNameByCurrency' as const;
export const StatsHttpGetBillingPriceListsByNameByCurrency =
  'StatsHttpGetBillingPriceListsByNameByCurrency' as const;
export const StatsHttpGetBillingRecipients =
  'StatsHttpGetBillingRecipients' as const;
export const StatsHttpPutBillingRecipients =
  'StatsHttpPutBillingRecipients' as const;
export const StatsHttpGetBillingSettings =
  'StatsHttpGetBillingSettings' as const;
export const StatsHttpPutBillingSettings =
  'StatsHttpPutBillingSettings' as const;
export const StatsHttpGetBillingStatus = 'StatsHttpGetBillingStatus' as const;
export const StatsHttpDeleteBillingBySystemDomainIdByBillingId =
  'StatsHttpDeleteBillingBySystemDomainIdByBillingId' as const;
export const StatsHttpGetBillingExpiration =
  'StatsHttpGetBillingExpiration' as const;
export const StatsHttpDeleteBillingExpirationBySystemDomainIdByBillingId =
  'StatsHttpDeleteBillingExpirationBySystemDomainIdByBillingId' as const;
export const StatsHttpPutBillingExpirationBySystemDomainIdByBillingId =
  'StatsHttpPutBillingExpirationBySystemDomainIdByBillingId' as const;
export const StatsHttpGetCollectionsByByPeriod =
  'StatsHttpGetCollectionsByByPeriod' as const;
export const StatsHttpGetCurrentUsage = 'StatsHttpGetCurrentUsage' as const;
export const StatsHttpGetIdByObjectIdInfo =
  'StatsHttpGetIdByObjectIdInfo' as const;
export const StatsHttpGetOrdwayBilling = 'StatsHttpGetOrdwayBilling' as const;
export const StatsHttpGetOrdwayBillingCustomer =
  'StatsHttpGetOrdwayBillingCustomer' as const;
export const StatsHttpGetOrdwayBillingInvoices =
  'StatsHttpGetOrdwayBillingInvoices' as const;
export const StatsHttpGetPaygoCosts = 'StatsHttpGetPaygoCosts' as const;
export const StatsHttpGetStorageAccessByByPeriod =
  'StatsHttpGetStorageAccessByByPeriod' as const;
export const StatsHttpGetStorageUsageByByPeriod =
  'StatsHttpGetStorageUsageByByPeriod' as const;
export const StatsHttpGetSystemLogsRecipients =
  'StatsHttpGetSystemLogsRecipients' as const;
export const StatsHttpPostSystemLogsRecipients =
  'StatsHttpPostSystemLogsRecipients' as const;
export const StatsHttpDeleteSystemLogsRecipientsByLogsRecipientId =
  'StatsHttpDeleteSystemLogsRecipientsByLogsRecipientId' as const;
export const StatsHttpGetSystemLogsRecipientsByLogsRecipientId =
  'StatsHttpGetSystemLogsRecipientsByLogsRecipientId' as const;
export const StatsHttpPatchSystemLogsRecipientsByLogsRecipientId =
  'StatsHttpPatchSystemLogsRecipientsByLogsRecipientId' as const;
export const StatsHttpPostSystemLogsRecipientsByLogsRecipientId =
  'StatsHttpPostSystemLogsRecipientsByLogsRecipientId' as const;
export const StatsHttpPutSystemLogsRecipientsByLogsRecipientId =
  'StatsHttpPutSystemLogsRecipientsByLogsRecipientId' as const;
export const StatsHttpGetTranscoderUsageByByPeriod =
  'StatsHttpGetTranscoderUsageByByPeriod' as const;
export const StatsHttpGetUserAuditByByPeriod =
  'StatsHttpGetUserAuditByByPeriod' as const;
export const StatsHttpGetUserLicensedBy = 'StatsHttpGetUserLicensedBy' as const;
export const StatsHttpGetV2Ping = 'StatsHttpGetV2Ping' as const;
export const StatsHttpGetV2PrometheusApiV1FormatQuery =
  'StatsHttpGetV2PrometheusApiV1FormatQuery' as const;
export const StatsHttpPostV2PrometheusApiV1FormatQuery =
  'StatsHttpPostV2PrometheusApiV1FormatQuery' as const;
export const StatsHttpGetV2PrometheusApiV1LabelByNameValues =
  'StatsHttpGetV2PrometheusApiV1LabelByNameValues' as const;
export const StatsHttpPostV2PrometheusApiV1LabelByNameValues =
  'StatsHttpPostV2PrometheusApiV1LabelByNameValues' as const;
export const StatsHttpGetV2PrometheusApiV1Labels =
  'StatsHttpGetV2PrometheusApiV1Labels' as const;
export const StatsHttpPostV2PrometheusApiV1Labels =
  'StatsHttpPostV2PrometheusApiV1Labels' as const;
export const StatsHttpGetV2PrometheusApiV1Query =
  'StatsHttpGetV2PrometheusApiV1Query' as const;
export const StatsHttpPostV2PrometheusApiV1Query =
  'StatsHttpPostV2PrometheusApiV1Query' as const;
export const StatsHttpGetV2PrometheusApiV1QueryRange =
  'StatsHttpGetV2PrometheusApiV1QueryRange' as const;
export const StatsHttpPostV2PrometheusApiV1QueryRange =
  'StatsHttpPostV2PrometheusApiV1QueryRange' as const;
export const StatsHttpGetV2PrometheusApiV1Series =
  'StatsHttpGetV2PrometheusApiV1Series' as const;
export const StatsHttpPostV2PrometheusApiV1Series =
  'StatsHttpPostV2PrometheusApiV1Series' as const;

/**
 * Original schema `AssetUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AssetUsageSchema}
 */
export interface StatsAssetUsageSchema {
  asset_id: string;
  asset_type?: 'ASSET' | 'SEQUENCE' | 'NLE_PROJECT' | 'PLACEHOLDER';
  date?: string;
  id?: string;
  metadata?: string;
  operation_source?:
    | 'COLLECTION'
    | 'SEARCH'
    | 'NOTIFICATION'
    | 'DISCOVERY'
    | 'SHARE'
    | 'EXTERNAL_SHARE'
    | '';
  operation_type:
    | 'VIEW'
    | 'PLAY'
    | 'PAUSE'
    | 'DELETE'
    | 'CREATE'
    | 'APPROVE'
    | 'REJECT'
    | 'COMMENT'
    | 'RENAME'
    | 'EXIT'
    | 'UNFOCUS'
    | 'REFOCUS'
    | 'SEEK';
  system_domain_id?: string;
  system_name: string;
  time?: string;
  user_id: string;
}
/**
 * Original schema `AssetUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AssetUsagesElasticSchema}
 */
export interface StatsAssetUsagesElasticSchema {
  count?: number;
  date?: string;
  id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `AssetUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AssetUsagesSchema}
 */
export interface StatsAssetUsagesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsAssetUsagesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `AutomationRunSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AutomationRunSchema}
 */
export interface StatsAutomationRunSchema {
  count?: number;
  date?: string;
  system_domain_id?: string;
}
/**
 * Original schema `AutomationRunsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AutomationRunsSchema}
 */
export interface StatsAutomationRunsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsAutomationRunSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `BillingCreditsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCreditsSchema}
 */
export interface StatsBillingCreditsSchema {
  auto_pay?: boolean;
  country?: string;
  credits: number;
  currency?: string;
  custom_message?: string;
  system_domain_id?: string;
  total?: string;
  vat?: number;
}
/**
 * Original schema `BillingCreditsVerifySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCreditsVerifySchema}
 */
export interface StatsBillingCreditsVerifySchema {
  charge?: string;
  invoice_id: string;
  system_domain_id?: string;
}
/**
 * Original schema `BillingCustomerCardSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCustomerCardSchema}
 */
export interface StatsBillingCustomerCardSchema {
  source: string;
}
/**
 * Original schema `BillingCustomerSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCustomerSchema}
 */
export interface StatsBillingCustomerSchema {
  business_vat_id?: string;
  email?: string;
  enable_subscription?: boolean;
  shipping: StatsBillingCustomerShipping;
}
/**
 * Original schema `BillingCustomerShipping`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCustomerShipping}
 */
export interface StatsBillingCustomerShipping {
  address: StatsBillingCustomerShippingAddress;
  name: string;
  phone?: string | null;
}
/**
 * Original schema `BillingCustomerShippingAddress`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCustomerShippingAddress}
 */
export interface StatsBillingCustomerShippingAddress {
  city: string;
  country: string;
  line1: string;
  line2?: string | null;
  postal_code: string;
  state?: string | null;
}
/**
 * Original schema `BillingCustomerShippingAddressSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCustomerShippingAddressSchema}
 */
export interface StatsBillingCustomerShippingAddressSchema {
  city: string;
  country: string;
  line1: string;
  line2?: string | null;
  postal_code: string;
  state?: string | null;
}
/**
 * Original schema `BillingCustomerShippingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingCustomerShippingSchema}
 */
export interface StatsBillingCustomerShippingSchema {
  address: StatsBillingCustomerShippingAddressSchema;
  name: string;
  phone?: string | null;
}
/**
 * Original schema `BillingExpirationUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingExpirationUpdateSchema}
 */
export interface StatsBillingExpirationUpdateSchema {
  expiration_date: string;
}
/**
 * Original schema `BillingReceiptSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingReceiptSchema}
 */
export interface StatsBillingReceiptSchema {
  receipt_url?: string;
}
/**
 * Original schema `BillingRecipientsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingRecipientsSchema}
 */
export interface StatsBillingRecipientsSchema {
  emails?: string[];
}
/**
 * Original schema `BillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingSchema}
 */
export interface StatsBillingSchema {
  balance?: number;
  consumption_subtype?: string;
  consumption_type?: string;
  currency?: ('USD' | 'EUR') | null;
  date?: string;
  expiration_date?: string | null;
  id?: string;
  label: string;
  price_list?: string | null;
  system_domain_id: string;
  value: number;
}
/**
 * Original schema `BillingSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingSettingsSchema}
 */
export interface StatsBillingSettingsSchema {
  auto_refill_amount?: number | null;
  enable_auto_top_up?: boolean;
  low_balance_trigger?: number | null;
}
/**
 * Original schema `BillingStatsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingStatsSchema}
 */
export interface StatsBillingStatsSchema {
  current_balance?: number;
  invoice_end_of_month?: boolean;
  new_billing_enabled?: boolean;
  stripe_id?: boolean;
  system_domain_status?: ('USD' | 'EUR') | null;
  system_domain_type: string;
  system_domain_warning_message: string;
}
/**
 * Original schema `BillingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingsSchema}
 */
export interface StatsBillingsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsBillingSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `CollectionUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CollectionUsageSchema}
 */
export interface StatsCollectionUsageSchema {
  collection_id: string;
  date?: string;
  id?: string;
  metadata?: string;
  operation_source?: 'COLLECTION' | 'SEARCH' | 'NOTIFICATION';
  operation_type: 'VIEW' | 'DELETE' | 'CREATE' | 'RENAME';
  system_domain_id?: string;
  system_name: string;
  time?: string;
  user_id: string;
}
/**
 * Original schema `CollectionUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CollectionUsagesElasticSchema}
 */
export interface StatsCollectionUsagesElasticSchema {
  count?: number;
  date?: string;
  id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `CollectionUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CollectionUsagesSchema}
 */
export interface StatsCollectionUsagesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsCollectionUsagesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `CreditsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CreditsSchema}
 */
export interface StatsCreditsSchema {
  country?: string;
  credits: number;
  currency?: string;
  total?: number;
  vat?: number;
}
/**
 * Original schema `CurrentUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CurrentUsageSchema}
 */
export interface StatsCurrentUsageSchema {
  assets_ai_metadata_filled?: number;
  automation_runs?: number;
  edge_transcoders?: number;
  external_storage?: number;
  images_analyzed?: number;
  images_face_recognition?: number;
  portals?: number;
  shield_enabled?: boolean;
  storage?: {
    [k: string]: unknown;
  };
  storage_gateway_clusters?: number;
  storage_gateway_nodes?: number;
  transcription_hours?: number;
  users?: {
    [k: string]: unknown;
  };
  video_analyzed_hours?: number;
  video_face_recognition_hours?: number;
}
/**
 * Original schema `DateFilterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-DateFilterSchema}
 */
export interface StatsDateFilterSchema {
  from_date?: string | null;
  to_date?: string | null;
}
/**
 * Original schema `HTTPValidationError`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-HTTPValidationError}
 */
export interface StatsHTTPValidationError {
  detail?: StatsValidationError[];
}
/**
 * Original schema `ValidationError`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-ValidationError}
 */
export interface StatsValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-ListObjectsSchema}
 */
export interface StatsListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `LogsRecipientReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-LogsRecipientReadSchema}
 */
export interface StatsLogsRecipientReadSchema {
  id?: string;
  method: 'GOOGLE' | 'AMAZON';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `LogsRecipientSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-LogsRecipientSchema}
 */
export interface StatsLogsRecipientSchema {
  id?: string;
  method: 'GOOGLE' | 'AMAZON';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `LogsRecipientsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-LogsRecipientsSchema}
 */
export interface StatsLogsRecipientsSchema {
  objects?: StatsLogsRecipientSchema[];
}
/**
 * Original schema `PaygoCostsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PaygoCostsSchema}
 */
export interface StatsPaygoCostsSchema {
  ai_metadata_cost?: number;
  analysis_cost?: number;
  automation_cost?: number;
  edge_transcoder_cost?: number;
  external_storage_cost?: number;
  face_recognition_cost?: number;
  shield_cost?: number;
  storage_costs?: {
    [k: string]: unknown;
  };
  total_spend?: number;
  transcription_cost?: number;
  user_costs?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `PingResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PingResponse}
 */
export interface StatsPingResponse {
  service?: string;
  status?: string;
  version?: string;
}
/**
 * Original schema `PriceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PriceSchema}
 */
export interface StatsPriceSchema {
  currency: 'EUR' | 'USD';
  name: string;
  prices: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `PricesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PricesSchema}
 */
export interface StatsPricesSchema {
  objects?: StatsPriceSchema[];
}
/**
 * Original schema `PrometheusFormatQueryResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusFormatQueryResponse}
 */
export interface StatsPrometheusFormatQueryResponse {
  data: string;
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusInstantQueryResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusInstantQueryResponse}
 */
export interface StatsPrometheusInstantQueryResponse {
  data:
    | StatsPrometheusVectorData
    | StatsPrometheusMatrixData
    | StatsPrometheusScalarData
    | StatsPrometheusStringData;
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusVectorData`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusVectorData}
 */
export interface StatsPrometheusVectorData {
  result: StatsPrometheusVectorSample[];
  resultType: 'vector';
}
/**
 * Original schema `PrometheusVectorSample`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusVectorSample}
 */
export interface StatsPrometheusVectorSample {
  metric: {
    [k: string]: string;
  };
  /**
   * @minItems 2
   * @maxItems 2
   */
  value: unknown[];
}
/**
 * Original schema `PrometheusMatrixData`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusMatrixData}
 */
export interface StatsPrometheusMatrixData {
  result: StatsPrometheusMatrixSeries[];
  resultType: 'matrix';
}
/**
 * Original schema `PrometheusMatrixSeries`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusMatrixSeries}
 */
export interface StatsPrometheusMatrixSeries {
  metric: {
    [k: string]: string;
  };
  values: unknown[][];
}
/**
 * Original schema `PrometheusScalarData`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusScalarData}
 */
export interface StatsPrometheusScalarData {
  /**
   * @minItems 2
   * @maxItems 2
   */
  result: unknown[];
  resultType: 'scalar';
}
/**
 * Original schema `PrometheusStringData`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusStringData}
 */
export interface StatsPrometheusStringData {
  /**
   * @minItems 2
   * @maxItems 2
   */
  result: unknown[];
  resultType: 'string';
}
/**
 * Original schema `PrometheusLabelValuesResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusLabelValuesResponse}
 */
export interface StatsPrometheusLabelValuesResponse {
  data: string[];
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusLabelsResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusLabelsResponse}
 */
export interface StatsPrometheusLabelsResponse {
  data: string[];
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusQueryRangeResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusQueryRangeResponse}
 */
export interface StatsPrometheusQueryRangeResponse {
  data: StatsPrometheusMatrixData;
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusSeriesResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusSeriesResponse}
 */
export interface StatsPrometheusSeriesResponse {
  data: {
    [k: string]: string;
  }[];
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `StorageAccessElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageAccessElasticSchema}
 */
export interface StatsStorageAccessElasticSchema {
  bucket_name?: string;
  bytes_received?: number;
  bytes_sent?: number;
  date?: string;
  id?: string;
  operations?: number;
  system_domain_id?: string;
}
/**
 * Original schema `StorageAccessSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageAccessSchema}
 */
export interface StatsStorageAccessSchema {
  bucket_name: string;
  bytes_received?: number;
  bytes_sent?: number;
  date?: string;
  id?: string;
  operation_type: string;
  operations?: number;
  storage_type:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'OMMS'
    | 'GCS'
    | 'B2'
    | 'AZURE'
    | 'TRANSFER';
  system_domain_id?: string;
  system_name: string;
}
/**
 * Original schema `StorageAccessesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageAccessesSchema}
 */
export interface StatsStorageAccessesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsStorageAccessElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `StorageUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageUsageSchema}
 */
export interface StatsStorageUsageSchema {
  bucket_name: string;
  bytes_stored?: number;
  date?: string;
  id?: string;
  storage_type:
    | 'FILE'
    | 'HTTP'
    | 'FTP'
    | 'SFTP'
    | 'S3'
    | 'OMMS'
    | 'GCS'
    | 'B2'
    | 'AZURE'
    | 'TRANSFER';
  system_domain_id?: string;
  system_name: string;
}
/**
 * Original schema `StorageUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageUsagesElasticSchema}
 */
export interface StatsStorageUsagesElasticSchema {
  bucket_name?: string;
  bytes_stored?: number;
  date?: string;
  id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `StorageUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageUsagesSchema}
 */
export interface StatsStorageUsagesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsStorageUsagesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `TranscoderUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TranscoderUsageSchema}
 */
export interface StatsTranscoderUsageSchema {
  adjusted_duration_seconds?: number | null;
  date?: string;
  destination_bytes?: number | null;
  duration_seconds?: number | null;
  id?: string;
  is_user_transcoder?: boolean;
  job_id?: string | null;
  object_id?: string | null;
  object_type?: string | null;
  operation_type?:
    | (
        | 'TRANSCODE'
        | 'TRANSCODE_AUDIO'
        | 'TRANSCODE_VIDEO'
        | 'TRANSCODE_IMAGE'
        | 'TRANSCODE_KEYFRAMES'
        | 'MEDIAINFO'
        | 'CONFORM'
        | 'EXTRACT_AUDIO'
        | 'EXTRACT_IMAGE'
        | 'ANALYZE'
        | 'TRANSCRIBE'
        | 'TRANSCRIBE_HUMAN'
        | 'FACE_RECOGNITION_IMAGE'
        | 'FACE_RECOGNITION_VIDEO'
      )
    | null;
  percent_done?: number | null;
  source_bytes?: number | null;
  status: 'FAILED' | 'FINISHED' | 'ABORTED';
  system_domain_id?: string;
  system_name: string;
  time?: string;
  transcoder_type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'FFMPEG_FIRST_FRAME'
    | 'IMAGEMAGICK'
    | 'SUBTITLES'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'GOOGLE_VISION'
    | 'COLLECTION_KEYFRAMES'
    | 'AMAZON_REKOGNITION_IMAGE'
    | 'AMAZON_REKOGNITION_VIDEO'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'MEDIAINFO'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'NONE'
    | 'REV_AI_TRANSCRIPTION'
    | 'GCVI_TRANSCRIPTION'
    | 'AMAZON_TRANSCRIBE'
    | 'OPEN_GRAPH'
    | 'LIBREOFFICE'
    | 'FACE_RECOGNITION'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LLM_METADATA';
}
/**
 * Original schema `TranscoderUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TranscoderUsagesElasticSchema}
 */
export interface StatsTranscoderUsagesElasticSchema {
  count?: number;
  date?: string;
  destination_bytes?: number;
  duration_seconds?: number;
  id?: string;
  is_user_transcoder?: boolean;
  operation_type?:
    | 'TRANSCODE'
    | 'TRANSCODE_AUDIO'
    | 'TRANSCODE_VIDEO'
    | 'TRANSCODE_IMAGE'
    | 'TRANSCODE_KEYFRAMES'
    | 'MEDIAINFO'
    | 'CONFORM'
    | 'EXTRACT_AUDIO'
    | 'EXTRACT_IMAGE'
    | 'ANALYZE'
    | 'TRANSCRIBE'
    | 'TRANSCRIBE_HUMAN'
    | 'FACE_RECOGNITION_IMAGE'
    | 'FACE_RECOGNITION_VIDEO';
  source_bytes?: number;
  system_domain_id?: string;
  transcoder_type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'FFMPEG_FIRST_FRAME'
    | 'IMAGEMAGICK'
    | 'SUBTITLES'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'GOOGLE_VISION'
    | 'COLLECTION_KEYFRAMES'
    | 'AMAZON_REKOGNITION_IMAGE'
    | 'AMAZON_REKOGNITION_VIDEO'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'MEDIAINFO'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'NONE'
    | 'REV_AI_TRANSCRIPTION'
    | 'GCVI_TRANSCRIPTION'
    | 'AMAZON_TRANSCRIBE'
    | 'OPEN_GRAPH'
    | 'LIBREOFFICE'
    | 'FACE_RECOGNITION'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LLM_METADATA';
}
/**
 * Original schema `TranscoderUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TranscoderUsagesSchema}
 */
export interface StatsTranscoderUsagesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsTranscoderUsagesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `TransferStatsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TransferStatsSchema}
 */
export interface StatsTransferStatsSchema {
  bytes_sent: number;
  ip?: string;
  object_info?: string;
  object_name?: string;
  time_taken_us?: number;
}
/**
 * Original schema `UnpublishedUserAuditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UnpublishedUserAuditSchema}
 */
export interface StatsUnpublishedUserAuditSchema {
  app_id?: string;
  client_ip?: string;
  date?: string;
  id?: string;
  is_acting_as_user?: boolean;
  log_recipient_id: string;
  metadata?: string;
  operation_result?: number;
  operation_type: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS';
  original_user_id?: string;
  payload?: string;
  request_id?: string;
  resource?: string;
  share_id?: string;
  share_user_id?: string;
  sudo?: boolean;
  system_domain_id?: string;
  system_name: string;
  time?: string;
  user_agent?: string;
  user_id?: string;
}
/**
 * Original schema `UserAuditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserAuditSchema}
 */
export interface StatsUserAuditSchema {
  app_id?: string;
  client_ip?: string;
  date?: string;
  id?: string;
  is_acting_as_user?: boolean;
  metadata?: string;
  operation_result?: number;
  operation_type: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS';
  original_user_id?: string;
  payload?: string;
  request_id?: string;
  resource?: string;
  share_id?: string;
  share_user_id?: string;
  sudo?: boolean;
  system_domain_id?: string;
  system_name: string;
  time?: string;
  user_agent?: string;
  user_id?: string;
}
/**
 * Original schema `UserUsagesDetailedSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserUsagesDetailedSchema}
 */
export interface StatsUserUsagesDetailedSchema {
  date?: string;
  system_domain_id?: string;
  type?: string;
  user_id?: string;
}
/**
 * Original schema `UserUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserUsagesElasticSchema}
 */
export interface StatsUserUsagesElasticSchema {
  count?: number;
  date?: string;
  id?: string;
  system_domain_id?: string;
  type?: string;
  user_email?: string;
  user_id?: string;
  user_name?: string;
}
/**
 * Original schema `UserUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserUsagesSchema}
 */
export interface StatsUserUsagesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: StatsUserUsagesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `AssetUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AssetUsageSchema}
 */
export interface StatsAssetUsageSchemaWithId {
  asset_id: string;
  asset_type?: 'ASSET' | 'SEQUENCE' | 'NLE_PROJECT' | 'PLACEHOLDER';
  date?: string;
  id: string;
  metadata?: string;
  operation_source?:
    | 'COLLECTION'
    | 'SEARCH'
    | 'NOTIFICATION'
    | 'DISCOVERY'
    | 'SHARE'
    | 'EXTERNAL_SHARE'
    | '';
  operation_type:
    | 'VIEW'
    | 'PLAY'
    | 'PAUSE'
    | 'DELETE'
    | 'CREATE'
    | 'APPROVE'
    | 'REJECT'
    | 'COMMENT'
    | 'RENAME'
    | 'EXIT'
    | 'UNFOCUS'
    | 'REFOCUS'
    | 'SEEK';
  system_domain_id?: string;
  system_name: string;
  time?: string;
  user_id: string;
}
/**
 * Original schema `AssetUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AssetUsageSchema}
 */
export interface StatsAssetUsageSchemaWithIdNullable {
  asset_id: string;
  asset_type?: ('ASSET' | 'SEQUENCE' | 'NLE_PROJECT' | 'PLACEHOLDER') | null;
  date?: string | null;
  id: string;
  metadata?: string | null;
  operation_source?:
    | (
        | 'COLLECTION'
        | 'SEARCH'
        | 'NOTIFICATION'
        | 'DISCOVERY'
        | 'SHARE'
        | 'EXTERNAL_SHARE'
        | ''
      )
    | null;
  operation_type:
    | 'VIEW'
    | 'PLAY'
    | 'PAUSE'
    | 'DELETE'
    | 'CREATE'
    | 'APPROVE'
    | 'REJECT'
    | 'COMMENT'
    | 'RENAME'
    | 'EXIT'
    | 'UNFOCUS'
    | 'REFOCUS'
    | 'SEEK';
  system_domain_id?: string | null;
  system_name: string;
  time?: string | null;
  user_id: string;
}
/**
 * Original schema `AutomationRunsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AutomationRunsSchema}
 */
export interface StatsAutomationRunsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: StatsAutomationRunSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `AutomationRunSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-AutomationRunSchema}
 */
export interface StatsAutomationRunSchemaNullable {
  count?: number | null;
  date?: string | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `BillingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingsSchema}
 */
export interface StatsBillingsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: StatsBillingSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `BillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingSchema}
 */
export interface StatsBillingSchemaWithIdNullable {
  balance?: number | null;
  consumption_subtype?: string | null;
  consumption_type?: string | null;
  currency?: ('USD' | 'EUR') | null;
  date?: string | null;
  expiration_date?: string | null;
  id: string;
  label: string;
  price_list?: string | null;
  system_domain_id: string;
  value: number;
}
/**
 * Original schema `BillingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingSchema}
 */
export interface StatsBillingSchemaWithId {
  balance?: number;
  consumption_subtype?: string;
  consumption_type?: string;
  currency?: ('USD' | 'EUR') | null;
  date?: string;
  expiration_date?: string | null;
  id: string;
  label: string;
  price_list?: string | null;
  system_domain_id: string;
  value: number;
}
/**
 * Original schema `BillingReceiptSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingReceiptSchema}
 */
export interface StatsBillingReceiptSchemaNullable {
  receipt_url?: string | null;
}
/**
 * Original schema `CreditsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CreditsSchema}
 */
export interface StatsCreditsSchemaNullable {
  country?: string | null;
  credits: number;
  currency?: string | null;
  total?: number | null;
  vat?: number | null;
}
/**
 * Original schema `PricesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PricesSchema}
 */
export interface StatsPricesSchemaWithId {
  objects: StatsPriceSchema[];
}
/**
 * Original schema `BillingRecipientsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingRecipientsSchema}
 */
export interface StatsBillingRecipientsSchemaNullable {
  emails?: string[] | null;
}
/**
 * Original schema `BillingSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingSettingsSchema}
 */
export interface StatsBillingSettingsSchemaNullable {
  auto_refill_amount?: number | null;
  enable_auto_top_up?: boolean | null;
  low_balance_trigger?: number | null;
}
/**
 * Original schema `BillingStatsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-BillingStatsSchema}
 */
export interface StatsBillingStatsSchemaNullable {
  current_balance?: number | null;
  invoice_end_of_month?: boolean | null;
  new_billing_enabled?: boolean | null;
  stripe_id?: boolean | null;
  system_domain_status?: ('USD' | 'EUR') | null;
  system_domain_type: string;
  system_domain_warning_message: string;
}
/**
 * Original schema `CollectionUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CollectionUsageSchema}
 */
export interface StatsCollectionUsageSchemaWithId {
  collection_id: string;
  date?: string;
  id: string;
  metadata?: string;
  operation_source?: 'COLLECTION' | 'SEARCH' | 'NOTIFICATION';
  operation_type: 'VIEW' | 'DELETE' | 'CREATE' | 'RENAME';
  system_domain_id?: string;
  system_name: string;
  time?: string;
  user_id: string;
}
/**
 * Original schema `CollectionUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CollectionUsageSchema}
 */
export interface StatsCollectionUsageSchemaWithIdNullable {
  collection_id: string;
  date?: string | null;
  id: string;
  metadata?: string | null;
  operation_source?: ('COLLECTION' | 'SEARCH' | 'NOTIFICATION') | null;
  operation_type: 'VIEW' | 'DELETE' | 'CREATE' | 'RENAME';
  system_domain_id?: string | null;
  system_name: string;
  time?: string | null;
  user_id: string;
}
/**
 * Original schema `CurrentUsageSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-CurrentUsageSchema}
 */
export interface StatsCurrentUsageSchemaNullable {
  assets_ai_metadata_filled?: number | null;
  automation_runs?: number | null;
  edge_transcoders?: number | null;
  external_storage?: number | null;
  images_analyzed?: number | null;
  images_face_recognition?: number | null;
  portals?: number | null;
  shield_enabled?: boolean | null;
  storage?: {
    [k: string]: unknown;
  } | null;
  storage_gateway_clusters?: number | null;
  storage_gateway_nodes?: number | null;
  transcription_hours?: number | null;
  users?: {
    [k: string]: unknown;
  } | null;
  video_analyzed_hours?: number | null;
  video_face_recognition_hours?: number | null;
}
/**
 * Original schema `PaygoCostsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PaygoCostsSchema}
 */
export interface StatsPaygoCostsSchemaNullable {
  ai_metadata_cost?: number | null;
  analysis_cost?: number | null;
  automation_cost?: number | null;
  edge_transcoder_cost?: number | null;
  external_storage_cost?: number | null;
  face_recognition_cost?: number | null;
  shield_cost?: number | null;
  storage_costs?: {
    [k: string]: unknown;
  } | null;
  total_spend?: number | null;
  transcription_cost?: number | null;
  user_costs?: {
    [k: string]: unknown;
  } | null;
}
/**
 * Original schema `StorageAccessesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageAccessesSchema}
 */
export interface StatsStorageAccessesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: StatsStorageAccessElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `StorageAccessElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageAccessElasticSchema}
 */
export interface StatsStorageAccessElasticSchemaWithIdNullable {
  bucket_name?: string | null;
  bytes_received?: number | null;
  bytes_sent?: number | null;
  date?: string | null;
  id: string;
  operations?: number | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `StorageAccessElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageAccessElasticSchema}
 */
export interface StatsStorageAccessElasticSchemaWithId {
  bucket_name?: string;
  bytes_received?: number;
  bytes_sent?: number;
  date?: string;
  id: string;
  operations?: number;
  system_domain_id?: string;
}
/**
 * Original schema `StorageUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageUsagesSchema}
 */
export interface StatsStorageUsagesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: StatsStorageUsagesElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `StorageUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageUsagesElasticSchema}
 */
export interface StatsStorageUsagesElasticSchemaWithIdNullable {
  bucket_name?: string | null;
  bytes_stored?: number | null;
  date?: string | null;
  id: string;
  system_domain_id?: string | null;
}
/**
 * Original schema `StorageUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-StorageUsagesElasticSchema}
 */
export interface StatsStorageUsagesElasticSchemaWithId {
  bucket_name?: string;
  bytes_stored?: number;
  date?: string;
  id: string;
  system_domain_id?: string;
}
/**
 * Original schema `LogsRecipientsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-LogsRecipientsSchema}
 */
export interface StatsLogsRecipientsSchemaWithId {
  objects: StatsLogsRecipientSchemaWithId[];
}
/**
 * Original schema `LogsRecipientSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-LogsRecipientSchema}
 */
export interface StatsLogsRecipientSchemaWithId {
  id: string;
  method: 'GOOGLE' | 'AMAZON';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `LogsRecipientReadSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-LogsRecipientReadSchema}
 */
export interface StatsLogsRecipientReadSchemaWithId {
  id: string;
  method: 'GOOGLE' | 'AMAZON';
  name: string;
  settings: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `TranscoderUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TranscoderUsagesSchema}
 */
export interface StatsTranscoderUsagesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: StatsTranscoderUsagesElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `TranscoderUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TranscoderUsagesElasticSchema}
 */
export interface StatsTranscoderUsagesElasticSchemaWithIdNullable {
  count?: number | null;
  date?: string | null;
  destination_bytes?: number | null;
  duration_seconds?: number | null;
  id: string;
  is_user_transcoder?: boolean | null;
  operation_type?:
    | (
        | 'TRANSCODE'
        | 'TRANSCODE_AUDIO'
        | 'TRANSCODE_VIDEO'
        | 'TRANSCODE_IMAGE'
        | 'TRANSCODE_KEYFRAMES'
        | 'MEDIAINFO'
        | 'CONFORM'
        | 'EXTRACT_AUDIO'
        | 'EXTRACT_IMAGE'
        | 'ANALYZE'
        | 'TRANSCRIBE'
        | 'TRANSCRIBE_HUMAN'
        | 'FACE_RECOGNITION_IMAGE'
        | 'FACE_RECOGNITION_VIDEO'
      )
    | null;
  source_bytes?: number | null;
  system_domain_id?: string | null;
  transcoder_type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'FFMPEG_FIRST_FRAME'
    | 'IMAGEMAGICK'
    | 'SUBTITLES'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'GOOGLE_VISION'
    | 'COLLECTION_KEYFRAMES'
    | 'AMAZON_REKOGNITION_IMAGE'
    | 'AMAZON_REKOGNITION_VIDEO'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'MEDIAINFO'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'NONE'
    | 'REV_AI_TRANSCRIPTION'
    | 'GCVI_TRANSCRIPTION'
    | 'AMAZON_TRANSCRIBE'
    | 'OPEN_GRAPH'
    | 'LIBREOFFICE'
    | 'FACE_RECOGNITION'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LLM_METADATA';
}
/**
 * Original schema `TranscoderUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-TranscoderUsagesElasticSchema}
 */
export interface StatsTranscoderUsagesElasticSchemaWithId {
  count?: number;
  date?: string;
  destination_bytes?: number;
  duration_seconds?: number;
  id: string;
  is_user_transcoder?: boolean;
  operation_type?:
    | 'TRANSCODE'
    | 'TRANSCODE_AUDIO'
    | 'TRANSCODE_VIDEO'
    | 'TRANSCODE_IMAGE'
    | 'TRANSCODE_KEYFRAMES'
    | 'MEDIAINFO'
    | 'CONFORM'
    | 'EXTRACT_AUDIO'
    | 'EXTRACT_IMAGE'
    | 'ANALYZE'
    | 'TRANSCRIBE'
    | 'TRANSCRIBE_HUMAN'
    | 'FACE_RECOGNITION_IMAGE'
    | 'FACE_RECOGNITION_VIDEO';
  source_bytes?: number;
  system_domain_id?: string;
  transcoder_type:
    | 'VANTAGE'
    | 'FFMPEG'
    | 'FFMPEG_FIRST_FRAME'
    | 'IMAGEMAGICK'
    | 'SUBTITLES'
    | 'ENCODING_COM'
    | 'ZENCODER'
    | 'TELESTREAM_CLOUD'
    | 'GOOGLE_VIDEO_INTELLIGENCE'
    | 'GOOGLE_VISION'
    | 'COLLECTION_KEYFRAMES'
    | 'AMAZON_REKOGNITION_IMAGE'
    | 'AMAZON_REKOGNITION_VIDEO'
    | 'ELEMENTAL_MEDIACONVERT'
    | 'ELEMENTAL_SERVER'
    | 'MEDIAINFO'
    | 'ICONIK_EDGE_TRANSCODER'
    | 'NONE'
    | 'REV_AI_TRANSCRIPTION'
    | 'GCVI_TRANSCRIPTION'
    | 'AMAZON_TRANSCRIBE'
    | 'OPEN_GRAPH'
    | 'LIBREOFFICE'
    | 'FACE_RECOGNITION'
    | 'FLICS'
    | 'WILDMOKA'
    | 'LLM_METADATA';
}
/**
 * Original schema `UserUsagesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserUsagesSchema}
 */
export interface StatsUserUsagesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: StatsUserUsagesElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `UserUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserUsagesElasticSchema}
 */
export interface StatsUserUsagesElasticSchemaWithIdNullable {
  count?: number | null;
  date?: string | null;
  id: string;
  system_domain_id?: string | null;
  type?: string | null;
  user_email?: string | null;
  user_id?: string | null;
  user_name?: string | null;
}
/**
 * Original schema `UserUsagesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-UserUsagesElasticSchema}
 */
export interface StatsUserUsagesElasticSchemaWithId {
  count?: number;
  date?: string;
  id: string;
  system_domain_id?: string;
  type?: string;
  user_email?: string;
  user_id?: string;
  user_name?: string;
}
/**
 * Original schema `PingResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PingResponse}
 */
export interface StatsPingResponseNullable {
  service?: string | null;
  status?: string | null;
  version?: string | null;
}
/**
 * Original schema `PrometheusFormatQueryResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusFormatQueryResponse}
 */
export interface StatsPrometheusFormatQueryResponseNullable {
  data: string;
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusLabelValuesResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusLabelValuesResponse}
 */
export interface StatsPrometheusLabelValuesResponseNullable {
  data: string[];
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusLabelsResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusLabelsResponse}
 */
export interface StatsPrometheusLabelsResponseNullable {
  data: string[];
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusInstantQueryResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusInstantQueryResponse}
 */
export interface StatsPrometheusInstantQueryResponseNullable {
  data:
    | StatsPrometheusVectorData
    | StatsPrometheusMatrixData
    | StatsPrometheusScalarData
    | StatsPrometheusStringData;
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusQueryRangeResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusQueryRangeResponse}
 */
export interface StatsPrometheusQueryRangeResponseNullable {
  data: StatsPrometheusMatrixData;
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}
/**
 * Original schema `PrometheusSeriesResponse`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#model-PrometheusSeriesResponse}
 */
export interface StatsPrometheusSeriesResponseNullable {
  data: {
    [k: string]: string;
  }[];
  infos?: string[] | null;
  status: 'success';
  warnings?: string[] | null;
}

/**
 * `POST /v1/assets/`
 *
 * Sets asset usage.
 *
 * <br/>system_domain_id will be automatically added when<br/>posting to this end point.
 *
 * Responses
 * - 201 - Usage entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsAssetUsageSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_assets_}
 */
export const httpPostAssets = (
  body: StatsAssetUsageSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostAssets,
  method: httpMethod.post,
  url: '/API/stats/v1/assets/',

  body,
  headers,
});

export interface StatsHttpGetAssetsByByPeriodQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
}

/**
 * `GET /v1/assets/by/{period}/`
 *
 * Returns all asset usage
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns asset usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsAssetUsageSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_assets_by__period__}
 */
export const httpGetAssetsByByPeriod = (
  period: string,
  query?: StatsHttpGetAssetsByByPeriodQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetAssetsByByPeriod,
  method: httpMethod.get,
  url: `/API/stats/v1/assets/by/${encodeURIComponent(period)}/`,
  params: { period },
  query,
  headers,
});

export interface StatsHttpGetAutomationsUsageByDayQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
}

/**
 * `GET /v1/automations/usage/by/day/`
 *
 * Returns automation runs by day.
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns automation runs by day
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsAutomationRunsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_automations_usage_by_day_}
 */
export const httpGetAutomationsUsageByDay = (
  query?: StatsHttpGetAutomationsUsageByDayQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetAutomationsUsageByDay,
  method: httpMethod.get,
  url: '/API/stats/v1/automations/usage/by/day/',

  query,
  headers,
});

export interface StatsHttpGetBillingQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by from_date
   */
  to_date?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/billing/`
 *
 * Returns billing info
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns billing data
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_}
 */
export const httpGetBilling = (
  query?: StatsHttpGetBillingQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetBilling,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/',

  query,
  headers,
});

/**
 * `POST /v1/billing/`
 *
 * Updates Billing (Requires super admin access).
 *
 *
 * Responses
 * - 201 - Usage entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_billing_}
 */
export const httpPostBilling = (
  body: StatsBillingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostBilling,
  method: httpMethod.post,
  url: '/API/stats/v1/billing/',

  body,
  headers,
});

/**
 * `GET /v1/billing/charges/{charge_id}/receipt_url/`
 *
 * Returns billing receipt
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Billing receipts
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link StatsBillingReceiptSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_charges__charge_id__receipt_url_}
 */
export const httpGetBillingChargesByChargeIdReceiptUrl = (
  chargeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetBillingChargesByChargeIdReceiptUrl,
  method: httpMethod.get,
  url: `/API/stats/v1/billing/charges/${encodeURIComponent(chargeId)}/receipt_url/`,
  params: { chargeId },
  headers,
});

/**
 * `POST /v1/billing/credits/`
 *
 * Add credits to an account
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Credits entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingCreditsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_billing_credits_}
 */
export const httpPostBillingCredits = (
  body: StatsBillingCreditsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostBillingCredits,
  method: httpMethod.post,
  url: '/API/stats/v1/billing/credits/',

  body,
  headers,
});

export interface StatsHttpGetBillingCreditsPriceQuery {
  credits: number;
}

/**
 * `GET /v1/billing/credits/price/`
 *
 * Checks the total price that needs to be paid including VAT if it's needed
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Credits entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsCreditsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_credits_price_}
 */
export const httpGetBillingCreditsPrice = (
  query?: StatsHttpGetBillingCreditsPriceQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetBillingCreditsPrice,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/credits/price/',

  query,
  headers,
});

/**
 * `POST /v1/billing/credits/verify/`
 *
 * Verify status of add credits to an account
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Credits entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingCreditsVerifySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_billing_credits_verify_}
 */
export const httpPostBillingCreditsVerify = (
  body: StatsBillingCreditsVerifySchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostBillingCreditsVerify,
  method: httpMethod.post,
  url: '/API/stats/v1/billing/credits/verify/',

  body,
  headers,
});

/**
 * `GET /v1/billing/customer/`
 *
 * Returns billing customer
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 201 - Usage entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link Stripe.Customer}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_customer_}
 */
export const httpGetBillingCustomer = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetBillingCustomer,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/customer/',

  headers,
});

/**
 * `POST /v1/billing/customer/`
 *
 * Updates billing customer
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Usage entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingCustomerSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_billing_customer_}
 */
export const httpPostBillingCustomer = (
  body: StatsBillingCustomerSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostBillingCustomer,
  method: httpMethod.post,
  url: '/API/stats/v1/billing/customer/',

  body,
  headers,
});

/**
 * `DELETE /v1/billing/customer/card/`
 *
 * Creates billing customer card
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 200 - Card deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/delete_v1_billing_customer_card_}
 */
export const httpDeleteBillingCustomerCard = (headers?: IconikApiHeaders) => ({
  id: StatsHttpDeleteBillingCustomerCard,
  method: httpMethod.delete,
  url: '/API/stats/v1/billing/customer/card/',

  headers,
});

/**
 * `POST /v1/billing/customer/card/`
 *
 * Creates billing customer card
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Usage entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingCustomerCardSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_billing_customer_card_}
 */
export const httpPostBillingCustomerCard = (
  body: StatsBillingCustomerCardSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostBillingCustomerCard,
  method: httpMethod.post,
  url: '/API/stats/v1/billing/customer/card/',

  body,
  headers,
});

export interface StatsHttpGetBillingInvoicesQuery {
  starting_after?: string;
  limit?: number;
}

/**
 * `GET /v1/billing/invoices/`
 *
 * Returns billing invoices
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Billing invoices
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link Stripe.ApiList<Stripe.Invoice>}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_invoices_}
 */
export const httpGetBillingInvoices = (
  query?: StatsHttpGetBillingInvoicesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetBillingInvoices,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/invoices/',

  query,
  headers,
});

/**
 * `GET /v1/billing/price_lists/`
 *
 * Get All Price Lists
 *
 *
 * Responses
 * - 200 - Prices
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsPricesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_price_lists_}
 */
export const httpGetBillingPriceLists = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetBillingPriceLists,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/price_lists/',

  headers,
});

/**
 * `PUT /v1/billing/price_lists/`
 *
 * Creates or updates a Price List
 *
 *
 * Responses
 * - 200 - Prices
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsPriceSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/put_v1_billing_price_lists_}
 */
export const httpPutBillingPriceLists = (
  body: StatsPriceSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPutBillingPriceLists,
  method: httpMethod.put,
  url: '/API/stats/v1/billing/price_lists/',

  body,
  headers,
});

/**
 * `DELETE /v1/billing/price_lists/{name}/{currency}/`
 *
 * Delete a Price list
 *
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/delete_v1_billing_price_lists__name___currency__}
 */
export const httpDeleteBillingPriceListsByNameByCurrency = (
  name: string,
  currency: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpDeleteBillingPriceListsByNameByCurrency,
  method: httpMethod.delete,
  url: `/API/stats/v1/billing/price_lists/${encodeURIComponent(name)}/${encodeURIComponent(currency)}/`,
  params: { name, currency },
  headers,
});

/**
 * `GET /v1/billing/price_lists/{name}/{currency}/`
 *
 * Get a Price List
 *
 *
 * Responses
 * - 200 - Prices
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsPriceSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_price_lists__name___currency__}
 */
export const httpGetBillingPriceListsByNameByCurrency = (
  name: string,
  currency: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetBillingPriceListsByNameByCurrency,
  method: httpMethod.get,
  url: `/API/stats/v1/billing/price_lists/${encodeURIComponent(name)}/${encodeURIComponent(currency)}/`,
  params: { name, currency },
  headers,
});

/**
 * `GET /v1/billing/recipients/`
 *
 * Updates Billing Recipients
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Email recipients
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingRecipientsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_recipients_}
 */
export const httpGetBillingRecipients = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetBillingRecipients,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/recipients/',

  headers,
});

/**
 * `PUT /v1/billing/recipients/`
 *
 * Updates Billing Recipients
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Email recipients
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingRecipientsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/put_v1_billing_recipients_}
 */
export const httpPutBillingRecipients = (
  body: StatsBillingRecipientsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPutBillingRecipients,
  method: httpMethod.put,
  url: '/API/stats/v1/billing/recipients/',

  body,
  headers,
});

/**
 * `GET /v1/billing/settings/`
 *
 * Updates Billing Settings
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Email recipients
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingSettingsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_settings_}
 */
export const httpGetBillingSettings = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetBillingSettings,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/settings/',

  headers,
});

/**
 * `PUT /v1/billing/settings/`
 *
 * Updates Billing Settings
 *
 * Required roles:
 *  - can_write_billing
 *
 * Responses
 * - 201 - Email recipients
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingSettingsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/put_v1_billing_settings_}
 */
export const httpPutBillingSettings = (
  body: StatsBillingSettingsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPutBillingSettings,
  method: httpMethod.put,
  url: '/API/stats/v1/billing/settings/',

  body,
  headers,
});

/**
 * `GET /v1/billing/status/`
 *
 * Returns billing status
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Billing status
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link StatsBillingStatsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_status_}
 */
export const httpGetBillingStatus = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetBillingStatus,
  method: httpMethod.get,
  url: '/API/stats/v1/billing/status/',

  headers,
});

/**
 * `DELETE /v1/billing/{system_domain_id}/{billing_id}/`
 *
 * Delete billing record (Requires super admin access).
 *
 *
 * Responses
 * - 204 - Usage deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/delete_v1_billing__system_domain_id___billing_id__}
 */
export const httpDeleteBillingBySystemDomainIdByBillingId = (
  systemDomainId: string,
  billingId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpDeleteBillingBySystemDomainIdByBillingId,
  method: httpMethod.delete,
  url: `/API/stats/v1/billing/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(billingId)}/`,
  params: { systemDomainId, billingId },
  headers,
});

export interface StatsHttpGetBillingExpirationQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
}

/**
 * `GET /v1/billing_expiration/`
 *
 * Returns billing expiration info
 *
 *
 * Responses
 * - 200 - Returns billing data
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_billing_expiration_}
 */
export const httpGetBillingExpiration = (
  query?: StatsHttpGetBillingExpirationQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetBillingExpiration,
  method: httpMethod.get,
  url: '/API/stats/v1/billing_expiration/',

  query,
  headers,
});

/**
 * `DELETE /v1/billing_expiration/{system_domain_id}/{billing_id}/`
 *
 * Delete billing expiration record (Requires super admin access).
 *
 *
 * Responses
 * - 204 - Billing expiration deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/delete_v1_billing_expiration__system_domain_id___billing_id__}
 */
export const httpDeleteBillingExpirationBySystemDomainIdByBillingId = (
  systemDomainId: string,
  billingId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpDeleteBillingExpirationBySystemDomainIdByBillingId,
  method: httpMethod.delete,
  url: `/API/stats/v1/billing_expiration/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(billingId)}/`,
  params: { systemDomainId, billingId },
  headers,
});

/**
 * `PUT /v1/billing_expiration/{system_domain_id}/{billing_id}/`
 *
 * Update billing expiration record (Requires super admin access).
 *
 *
 * Responses
 * - 200 - Billing expiration updated
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/put_v1_billing_expiration__system_domain_id___billing_id__}
 */
export const httpPutBillingExpirationBySystemDomainIdByBillingId = (
  systemDomainId: string,
  billingId: string,
  body: StatsBillingExpirationUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPutBillingExpirationBySystemDomainIdByBillingId,
  method: httpMethod.put,
  url: `/API/stats/v1/billing_expiration/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(billingId)}/`,
  params: { systemDomainId, billingId },
  body,
  headers,
});

export interface StatsHttpGetCollectionsByByPeriodQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
}

/**
 * `GET /v1/collections/by/{period}/`
 *
 * Returns all collection usage
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns Collection usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsCollectionUsageSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_collections_by__period__}
 */
export const httpGetCollectionsByByPeriod = (
  period: string,
  query?: StatsHttpGetCollectionsByByPeriodQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetCollectionsByByPeriod,
  method: httpMethod.get,
  url: `/API/stats/v1/collections/by/${encodeURIComponent(period)}/`,
  params: { period },
  query,
  headers,
});

export interface StatsHttpGetCurrentUsageQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
}

/**
 * `GET /v1/current_usage/`
 *
 * Returns current usage for system domains
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns current usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsCurrentUsageSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_current_usage_}
 */
export const httpGetCurrentUsage = (
  query?: StatsHttpGetCurrentUsageQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetCurrentUsage,
  method: httpMethod.get,
  url: '/API/stats/v1/current_usage/',

  query,
  headers,
});

/**
 * `GET /v1/id/{object_id}/info/`
 *
 * Internal endpoint to convert ID to system domain
 *
 *
 * Responses
 * - 200 - Returns asset usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_id__object_id__info_}
 */
export const httpGetIdByObjectIdInfo = (
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetIdByObjectIdInfo,
  method: httpMethod.get,
  url: `/API/stats/v1/id/${encodeURIComponent(objectId)}/info/`,
  params: { objectId },
  headers,
});

export interface StatsHttpGetOrdwayBillingQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by from_date
   */
  to_date?: string;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
}

/**
 * `GET /v1/ordway/billing/`
 *
 * Returns billing info
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns billing data
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_ordway_billing_}
 */
export const httpGetOrdwayBilling = (
  query?: StatsHttpGetOrdwayBillingQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetOrdwayBilling,
  method: httpMethod.get,
  url: '/API/stats/v1/ordway/billing/',

  query,
  headers,
});

/**
 * `GET /v1/ordway/billing/customer/`
 *
 * Returns billing customer
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 201 - Usage entered
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsBillingSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_ordway_billing_customer_}
 */
export const httpGetOrdwayBillingCustomer = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetOrdwayBillingCustomer,
  method: httpMethod.get,
  url: '/API/stats/v1/ordway/billing/customer/',

  headers,
});

export interface StatsHttpGetOrdwayBillingInvoicesQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
}

/**
 * `GET /v1/ordway/billing/invoices/`
 *
 * Returns billing invoices
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Billing invoices
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_ordway_billing_invoices_}
 */
export const httpGetOrdwayBillingInvoices = (
  query?: StatsHttpGetOrdwayBillingInvoicesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetOrdwayBillingInvoices,
  method: httpMethod.get,
  url: '/API/stats/v1/ordway/billing/invoices/',

  query,
  headers,
});

/**
 * `GET /v1/paygo_costs/`
 *
 * Returns monthly costs from billing
 *
 * Required roles:
 *  - can_read_billing
 *
 * Responses
 * - 200 - Returns billing data
 * - 401 - Token is invalid
 *
 * Response {@link StatsPaygoCostsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_paygo_costs_}
 */
export const httpGetPaygoCosts = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetPaygoCosts,
  method: httpMethod.get,
  url: '/API/stats/v1/paygo_costs/',

  headers,
});

export interface StatsHttpGetStorageAccessByByPeriodQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
}

/**
 * `GET /v1/storage/access/by/{period}/`
 *
 * Returns storage_access for all storages
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns a object for storage access
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsStorageAccessesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_storage_access_by__period__}
 */
export const httpGetStorageAccessByByPeriod = (
  period: string,
  query?: StatsHttpGetStorageAccessByByPeriodQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetStorageAccessByByPeriod,
  method: httpMethod.get,
  url: `/API/stats/v1/storage/access/by/${encodeURIComponent(period)}/`,
  params: { period },
  query,
  headers,
});

export interface StatsHttpGetStorageUsageByByPeriodQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
}

/**
 * `GET /v1/storage/usage/by/{period}/`
 *
 * Returns storage_usage for all storages
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns storage usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsStorageUsagesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_storage_usage_by__period__}
 */
export const httpGetStorageUsageByByPeriod = (
  period: string,
  query?: StatsHttpGetStorageUsageByByPeriodQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetStorageUsageByByPeriod,
  method: httpMethod.get,
  url: `/API/stats/v1/storage/usage/by/${encodeURIComponent(period)}/`,
  params: { period },
  query,
  headers,
});

export interface StatsHttpGetSystemLogsRecipientsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last service account set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/system/logs/recipients/`
 *
 * Get logs recipients settings
 *
 * Required roles:
 *  - can_read_logs_recipients
 *
 * Responses
 * - 200 - Returns logs recipients settings
 * - 401 - Token is invalid
 * - 404 - Logs recipients settings don't exist
 *
 * Response {@link StatsLogsRecipientsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_system_logs_recipients_}
 */
export const httpGetSystemLogsRecipients = (
  query?: StatsHttpGetSystemLogsRecipientsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetSystemLogsRecipients,
  method: httpMethod.get,
  url: '/API/stats/v1/system/logs/recipients/',

  query,
  headers,
});

/**
 * `POST /v1/system/logs/recipients/`
 *
 * Create logs recipient settings
 *
 * Required roles:
 *  - can_write_logs_recipients
 *
 * Responses
 * - 201 - Returns a logs_recipient object
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link StatsLogsRecipientReadSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_system_logs_recipients_}
 */
export const httpPostSystemLogsRecipients = (
  body: StatsLogsRecipientSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostSystemLogsRecipients,
  method: httpMethod.post,
  url: '/API/stats/v1/system/logs/recipients/',

  body,
  headers,
});

/**
 * `DELETE /v1/system/logs/recipients/{logs_recipient_id}/`
 *
 * Delete logs recipient settings
 *
 * Required roles:
 *  - can_delete_logs_recipients
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Logs recipient doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/delete_v1_system_logs_recipients__logs_recipient_id__}
 */
export const httpDeleteSystemLogsRecipientsByLogsRecipientId = (
  logsRecipientId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpDeleteSystemLogsRecipientsByLogsRecipientId,
  method: httpMethod.delete,
  url: `/API/stats/v1/system/logs/recipients/${encodeURIComponent(logsRecipientId)}/`,
  params: { logsRecipientId },
  headers,
});

/**
 * `GET /v1/system/logs/recipients/{logs_recipient_id}/`
 *
 * Get settings of a logs recipient
 *
 * Required roles:
 *  - can_read_logs_recipients
 *
 * Responses
 * - 200 - Returns settings for a logs recipients
 * - 401 - Token is invalid
 * - 404 - Logs recipients settings don't exist
 *
 * Response {@link StatsLogsRecipientReadSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_system_logs_recipients__logs_recipient_id__}
 */
export const httpGetSystemLogsRecipientsByLogsRecipientId = (
  logsRecipientId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetSystemLogsRecipientsByLogsRecipientId,
  method: httpMethod.get,
  url: `/API/stats/v1/system/logs/recipients/${encodeURIComponent(logsRecipientId)}/`,
  params: { logsRecipientId },
  headers,
});

export type StatsLogsRecipientSchemaPartial = Partial<StatsLogsRecipientSchema>;

/**
 * `PATCH /v1/system/logs/recipients/{logs_recipient_id}/`
 *
 * Change logs recipient settings
 *
 * Required roles:
 *  - can_write_logs_recipients
 *
 * Responses
 * - 200 - Returns changed system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Logs recipient doesn't exist
 *
 * Response {@link StatsLogsRecipientReadSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/patch_v1_system_logs_recipients__logs_recipient_id__}
 */
export const httpPatchSystemLogsRecipientsByLogsRecipientId = (
  logsRecipientId: string,
  body: StatsLogsRecipientSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPatchSystemLogsRecipientsByLogsRecipientId,
  method: httpMethod.patch,
  url: `/API/stats/v1/system/logs/recipients/${encodeURIComponent(logsRecipientId)}/`,
  params: { logsRecipientId },
  body,
  headers,
});

/**
 * Returns a document describing storage access
 */
export interface StatsHttpPostSystemLogsRecipientsByLogsRecipientIdResponse {
  access_check?: boolean;
  error_message?: string;
}

/**
 * `POST /v1/system/logs/recipients/{logs_recipient_id}/`
 *
 * Test logs recipient connection
 *
 * Required roles:
 *  - can_write_logs_recipients
 *
 * Responses
 * - 200 - Returns a document describing storage access
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Logs recipient doesn't exist
 *
 * Response {@link StatsHttpPostSystemLogsRecipientsByLogsRecipientIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v1_system_logs_recipients__logs_recipient_id__}
 */
export const httpPostSystemLogsRecipientsByLogsRecipientId = (
  logsRecipientId: string,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostSystemLogsRecipientsByLogsRecipientId,
  method: httpMethod.post,
  url: `/API/stats/v1/system/logs/recipients/${encodeURIComponent(logsRecipientId)}/`,
  params: { logsRecipientId },
  headers,
});

/**
 * `PUT /v1/system/logs/recipients/{logs_recipient_id}/`
 *
 * Change logs recipient settings
 *
 * Required roles:
 *  - can_write_logs_recipients
 *
 * Responses
 * - 200 - Returns changed system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Logs recipient doesn't exist
 *
 * Response {@link StatsLogsRecipientReadSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/put_v1_system_logs_recipients__logs_recipient_id__}
 */
export const httpPutSystemLogsRecipientsByLogsRecipientId = (
  logsRecipientId: string,
  body: StatsLogsRecipientSchema,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPutSystemLogsRecipientsByLogsRecipientId,
  method: httpMethod.put,
  url: `/API/stats/v1/system/logs/recipients/${encodeURIComponent(logsRecipientId)}/`,
  params: { logsRecipientId },
  body,
  headers,
});

export interface StatsHttpGetTranscoderUsageByByPeriodQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
}

/**
 * `GET /v1/transcoder/usage/by/{period}/`
 *
 * Returns transcoder_usage for all transcoders
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns a transcoder usage objects
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsTranscoderUsagesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_transcoder_usage_by__period__}
 */
export const httpGetTranscoderUsageByByPeriod = (
  period: string,
  query?: StatsHttpGetTranscoderUsageByByPeriodQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetTranscoderUsageByByPeriod,
  method: httpMethod.get,
  url: `/API/stats/v1/transcoder/usage/by/${encodeURIComponent(period)}/`,
  params: { period },
  query,
  headers,
});

export interface StatsHttpGetUserAuditByByPeriodQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
  /**
   * Filter by system_domain_id (Only for super admins)
   */
  system_domain_id?: string;
}

/**
 * `GET /v1/user/audit/by/{period}/`
 *
 * Returns all audit
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns user usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsUserUsagesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_user_audit_by__period__}
 */
export const httpGetUserAuditByByPeriod = (
  period: string,
  query?: StatsHttpGetUserAuditByByPeriodQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetUserAuditByByPeriod,
  method: httpMethod.get,
  url: `/API/stats/v1/user/audit/by/${encodeURIComponent(period)}/`,
  params: { period },
  query,
  headers,
});

export interface StatsHttpGetUserLicensedByQuery {
  /**
   * Filter by from_date
   */
  from_date?: string;
  /**
   * Filter by to_date
   */
  to_date?: string;
  /**
   * Filter by system_domain_id (Only for super admins)
   */
  system_domain_id?: string;
}

/**
 * `GET /v1/user/licensed/by/`
 *
 * Returns licensed user usage
 *
 * Required roles:
 *  - can_read_stats
 *
 * Responses
 * - 200 - Returns licensed user usage
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link StatsUserUsagesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v1_user_licensed_by_}
 */
export const httpGetUserLicensedBy = (
  query?: StatsHttpGetUserLicensedByQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetUserLicensedBy,
  method: httpMethod.get,
  url: '/API/stats/v1/user/licensed/by/',

  query,
  headers,
});

/**
 * `GET /v2/ping/`
 *
 * Routing health check
 *
 * Lightweight endpoint to verify gateway routing to stats-v2.
 *
 * Responses
 * - 200 - Successful Response
 *
 * Response {@link StatsPingResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_ping_}
 */
export const httpGetV2Ping = (headers?: IconikApiHeaders) => ({
  id: StatsHttpGetV2Ping,
  method: httpMethod.get,
  url: '/API/stats/v2/ping/',

  headers,
});

export interface StatsHttpGetV2PrometheusApiV1FormatQueryQuery {
  /**
   * PromQL expression. Must not mention the domain label; the server scopes every selector to the caller's domain.
   */
  query: string;
}

/**
 * `GET /v2/prometheus/api/v1/format_query`
 *
 * Pretty-print a PromQL expression
 *
 * Prometheus `/api/v1/format_query`. Validates and formats the expression; it reads no series data.
 *
 * Example: `query=sum by (asset_type) (iconik_assets_total)`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusFormatQueryResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_prometheus_api_v1_format_query}
 */
export const httpGetV2PrometheusApiV1FormatQuery = (
  query?: StatsHttpGetV2PrometheusApiV1FormatQueryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetV2PrometheusApiV1FormatQuery,
  method: httpMethod.get,
  url: '/API/stats/v2/prometheus/api/v1/format_query',

  query,
  headers,
});

export interface StatsHttpPostV2PrometheusApiV1FormatQueryQuery {
  /**
   * PromQL expression. Must not mention the domain label; the server scopes every selector to the caller's domain.
   */
  query: string;
}

/**
 * `POST /v2/prometheus/api/v1/format_query`
 *
 * Pretty-print a PromQL expression
 *
 * Prometheus `/api/v1/format_query`. Validates and formats the expression; it reads no series data.
 *
 * Example: `query=sum by (asset_type) (iconik_assets_total)`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusFormatQueryResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v2_prometheus_api_v1_format_query}
 */
export const httpPostV2PrometheusApiV1FormatQuery = (
  query?: StatsHttpPostV2PrometheusApiV1FormatQueryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostV2PrometheusApiV1FormatQuery,
  method: httpMethod.post,
  url: '/API/stats/v2/prometheus/api/v1/format_query',

  query,
  headers,
});

export interface StatsHttpGetV2PrometheusApiV1LabelByNameValuesQuery {
  /**
   * Repeated series selector.
   */
  'match[]'?: string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start?: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end?: string;
}

/**
 * `GET /v2/prometheus/api/v1/label/{name}/values`
 *
 * Values of one label
 *
 * Prometheus `/api/v1/label/<name>/values`, scoped to the caller's domain.
 *
 * Example: `/api/v1/label/asset_type/values?match[]=iconik_assets_total`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusLabelValuesResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_prometheus_api_v1_label__name__values}
 */
export const httpGetV2PrometheusApiV1LabelByNameValues = (
  name: string,
  query?: StatsHttpGetV2PrometheusApiV1LabelByNameValuesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetV2PrometheusApiV1LabelByNameValues,
  method: httpMethod.get,
  url: `/API/stats/v2/prometheus/api/v1/label/${encodeURIComponent(name)}/values`,
  params: { name },
  query,
  headers,
});

export interface StatsHttpPostV2PrometheusApiV1LabelByNameValuesQuery {
  /**
   * Repeated series selector.
   */
  'match[]'?: string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start?: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end?: string;
}

/**
 * `POST /v2/prometheus/api/v1/label/{name}/values`
 *
 * Values of one label
 *
 * Prometheus `/api/v1/label/<name>/values`, scoped to the caller's domain.
 *
 * Example: `/api/v1/label/asset_type/values?match[]=iconik_assets_total`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusLabelValuesResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v2_prometheus_api_v1_label__name__values}
 */
export const httpPostV2PrometheusApiV1LabelByNameValues = (
  name: string,
  query?: StatsHttpPostV2PrometheusApiV1LabelByNameValuesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostV2PrometheusApiV1LabelByNameValues,
  method: httpMethod.post,
  url: `/API/stats/v2/prometheus/api/v1/label/${encodeURIComponent(name)}/values`,
  params: { name },
  query,
  headers,
});

export interface StatsHttpGetV2PrometheusApiV1LabelsQuery {
  /**
   * Repeated series selector.
   */
  'match[]'?: string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start?: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end?: string;
}

/**
 * `GET /v2/prometheus/api/v1/labels`
 *
 * Label names
 *
 * Prometheus `/api/v1/labels`, scoped to the caller's domain. With no `match[]` a bare domain selector is used, so only the caller's own labels are returned.
 *
 * Example: `match[]=iconik_assets_total`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusLabelsResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_prometheus_api_v1_labels}
 */
export const httpGetV2PrometheusApiV1Labels = (
  query?: StatsHttpGetV2PrometheusApiV1LabelsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetV2PrometheusApiV1Labels,
  method: httpMethod.get,
  url: '/API/stats/v2/prometheus/api/v1/labels',

  query,
  headers,
});

export interface StatsHttpPostV2PrometheusApiV1LabelsQuery {
  /**
   * Repeated series selector.
   */
  'match[]'?: string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start?: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end?: string;
}

/**
 * `POST /v2/prometheus/api/v1/labels`
 *
 * Label names
 *
 * Prometheus `/api/v1/labels`, scoped to the caller's domain. With no `match[]` a bare domain selector is used, so only the caller's own labels are returned.
 *
 * Example: `match[]=iconik_assets_total`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusLabelsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v2_prometheus_api_v1_labels}
 */
export const httpPostV2PrometheusApiV1Labels = (
  query?: StatsHttpPostV2PrometheusApiV1LabelsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostV2PrometheusApiV1Labels,
  method: httpMethod.post,
  url: '/API/stats/v2/prometheus/api/v1/labels',

  query,
  headers,
});

export interface StatsHttpGetV2PrometheusApiV1QueryQuery {
  /**
   * PromQL expression. Must not mention the domain label; the server scopes every selector to the caller's domain.
   */
  query: string;
  /**
   * Evaluation timestamp (RFC 3339 or unix seconds). Defaults to now.
   */
  time?: string;
}

/**
 * `GET /v2/prometheus/api/v1/query`
 *
 * Instant query
 *
 * Prometheus `/api/v1/query`, scoped to the caller's domain.
 *
 * Example: `query=sum by (asset_type) (iconik_assets_total)`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusInstantQueryResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_prometheus_api_v1_query}
 */
export const httpGetV2PrometheusApiV1Query = (
  query?: StatsHttpGetV2PrometheusApiV1QueryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetV2PrometheusApiV1Query,
  method: httpMethod.get,
  url: '/API/stats/v2/prometheus/api/v1/query',

  query,
  headers,
});

export interface StatsHttpPostV2PrometheusApiV1QueryQuery {
  /**
   * PromQL expression. Must not mention the domain label; the server scopes every selector to the caller's domain.
   */
  query: string;
  /**
   * Evaluation timestamp (RFC 3339 or unix seconds). Defaults to now.
   */
  time?: string;
}

/**
 * `POST /v2/prometheus/api/v1/query`
 *
 * Instant query
 *
 * Prometheus `/api/v1/query`, scoped to the caller's domain.
 *
 * Example: `query=sum by (asset_type) (iconik_assets_total)`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusInstantQueryResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v2_prometheus_api_v1_query}
 */
export const httpPostV2PrometheusApiV1Query = (
  query?: StatsHttpPostV2PrometheusApiV1QueryQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostV2PrometheusApiV1Query,
  method: httpMethod.post,
  url: '/API/stats/v2/prometheus/api/v1/query',

  query,
  headers,
});

export interface StatsHttpGetV2PrometheusApiV1QueryRangeQuery {
  /**
   * PromQL expression. Must not mention the domain label; the server scopes every selector to the caller's domain.
   */
  query: string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end: string;
  /**
   * Query resolution step, e.g. `1h` or seconds.
   */
  step: string;
}

/**
 * `GET /v2/prometheus/api/v1/query_range`
 *
 * Range query
 *
 * Prometheus `/api/v1/query_range`, scoped to the caller's domain. The number of points (`(end-start)/step`) and the lookback window are capped.
 *
 * Example: `query=sum(rate(iconik_assets_created_total[1d]))&step=1d`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusQueryRangeResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_prometheus_api_v1_query_range}
 */
export const httpGetV2PrometheusApiV1QueryRange = (
  query?: StatsHttpGetV2PrometheusApiV1QueryRangeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetV2PrometheusApiV1QueryRange,
  method: httpMethod.get,
  url: '/API/stats/v2/prometheus/api/v1/query_range',

  query,
  headers,
});

export interface StatsHttpPostV2PrometheusApiV1QueryRangeQuery {
  /**
   * PromQL expression. Must not mention the domain label; the server scopes every selector to the caller's domain.
   */
  query: string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end: string;
  /**
   * Query resolution step, e.g. `1h` or seconds.
   */
  step: string;
}

/**
 * `POST /v2/prometheus/api/v1/query_range`
 *
 * Range query
 *
 * Prometheus `/api/v1/query_range`, scoped to the caller's domain. The number of points (`(end-start)/step`) and the lookback window are capped.
 *
 * Example: `query=sum(rate(iconik_assets_created_total[1d]))&step=1d`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusQueryRangeResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v2_prometheus_api_v1_query_range}
 */
export const httpPostV2PrometheusApiV1QueryRange = (
  query?: StatsHttpPostV2PrometheusApiV1QueryRangeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostV2PrometheusApiV1QueryRange,
  method: httpMethod.post,
  url: '/API/stats/v2/prometheus/api/v1/query_range',

  query,
  headers,
});

export interface StatsHttpGetV2PrometheusApiV1SeriesQuery {
  /**
   * Repeated series selector.
   */
  'match[]': string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start?: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end?: string;
}

/**
 * `GET /v2/prometheus/api/v1/series`
 *
 * Series matching a selector
 *
 * Prometheus `/api/v1/series`, scoped to the caller's domain.
 *
 * Example: `match[]={__name__=~"iconik_.+"}`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusSeriesResponseNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/get_v2_prometheus_api_v1_series}
 */
export const httpGetV2PrometheusApiV1Series = (
  query?: StatsHttpGetV2PrometheusApiV1SeriesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpGetV2PrometheusApiV1Series,
  method: httpMethod.get,
  url: '/API/stats/v2/prometheus/api/v1/series',

  query,
  headers,
});

export interface StatsHttpPostV2PrometheusApiV1SeriesQuery {
  /**
   * Repeated series selector.
   */
  'match[]': string;
  /**
   * Start timestamp (RFC 3339 or unix seconds).
   */
  start?: string;
  /**
   * End timestamp (RFC 3339 or unix seconds).
   */
  end?: string;
}

/**
 * `POST /v2/prometheus/api/v1/series`
 *
 * Series matching a selector
 *
 * Prometheus `/api/v1/series`, scoped to the caller's domain.
 *
 * Example: `match[]={__name__=~"iconik_.+"}`
 *
 * Required roles:
 * - can_read_insights
 *
 * Responses
 * - 200 - Successful Response
 * - 422 - Validation Error
 *
 * Response {@link StatsPrometheusSeriesResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/stats/spec/#/default/post_v2_prometheus_api_v1_series}
 */
export const httpPostV2PrometheusApiV1Series = (
  query?: StatsHttpPostV2PrometheusApiV1SeriesQuery,
  headers?: IconikApiHeaders,
) => ({
  id: StatsHttpPostV2PrometheusApiV1Series,
  method: httpMethod.post,
  url: '/API/stats/v2/prometheus/api/v1/series',

  query,
  headers,
});
